import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import productSearch from './views/product-search'

export default [
  {
    path: RoutePathConstants.PRODUCT_SEARCH,
    name: 'productSearch',
    component: productSearch
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/routers.js